import ProductTypeIcon from './ProductTypeIcon';

export default ProductTypeIcon;
